<template>
  <div class="card_box">
    <el-tabs style="background: white" v-model="activeName" class="demo-tabs" @tab-click="handleClick">
      <el-tab-pane
          :label="$t('common.customer.level.setting')"
          name="1"
          v-if="isSuperAdmin"
          lazy
      >
        <TableEditeInput/>
      </el-tab-pane>
      <el-tab-pane
          :label="$t('common.customer.setting.followup')"
          name="2"
          style="padding: 6px !important;"
          v-if="isSuperAdmin"
          lazy
      >
        <!-- 自定义 -->
        <MyAlert/>
        <FollowClient/>
        <div class="table_tops">
          <div style="font-size: 13px">{{ $t("common.customer.info4") }}</div>
          <div class="show_userName" v-for="item in showCheckList">{{ item.userName }}</div>
          <el-button type="primary" link @click="showDialog"
          >{{ $t("common.member.add") }}
          </el-button
          >
        </div>
        <el-dialog
            v-model="dialogVisible"
            :title="$t('common.customer.info5')"
            width="30%"
            :before-close="handleClose"
        >
          <el-checkbox-group v-model="checkList">
            <el-checkbox
                v-for="item in AllTableData"
                :label="JSON.stringify({id: item.id, userId: item.userId})"
                :key="item.id"
            >{{ item.userName }}
            </el-checkbox
            >
          </el-checkbox-group>
          <template #footer>
            <span class="dialog-footer">
              <el-button size="small" @click="dialogVisible = false">{{ $t("common.sss16") }}</el-button>
              <el-button size="small" type="primary" @click="updateFollowUsers">
                {{ $t("common.confirm") }}

              </el-button>
            </span>
          </template>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane
          v-if="isSuperAdmin||isAdmin"
          :label="$t('setting.biao.qian.tab')"
          name="5"
          lazy
      >
        <labelSetting></labelSetting>
      </el-tab-pane>
      <el-tab-pane
          :label="$t('common.customer.branch.setting')"
          name="3"
          style="padding: 6px !important;"
          lazy
      >
        <TopSearch ref="topSearchRef" :adminShow="true" :searchShow="true" :isSetting="true" @searchKey="getSearchKey"/>
        <div>
          <div class="top_tips">
            <h2 style="font-weight: 500;font-size: 16px !important;">{{ $t('common.customer.branch.setting') }}</h2>
            <div>
              <el-button
                  type="primary"
                  @click="handleClickBranch"
                  size="small"
                  :icon="UserFilled"
              >{{ $t('common.customer.branch.batch') }}
              </el-button
              >
              <el-button
                  size="small"
                  type="primary"
                  :icon="Remove"
                  @click="handleClickRemove"
              >{{ $t('common.move.to.seas') }}
              </el-button
              >
            </div>
          </div>
          <!-- 客户分管设置 -->
          <el-table
              v-loading="isLoading"
              :data="customerList"
              :style="{width: '100%', marginTop: '16px',minHeight:customerList.length===0?'200':customerList.length-1<10?'max-content':'580px'}"
              @selection-change="handleSelectionChange"
              @select="handleCheck"
              @select-all="handleClickSelectAll"
              :cell-style="rowClassName"
              ref="targetTable"
              :header-cell-style="headerClassName"
              :height="customerList.length-1<10?'max-content':'560px'"
              :row-key="row => row.id"
              @cell-mouse-leave="clearVisiblePopover"
              @row-click="handleClickTargetData"
          >
            <el-table-column :selectable="checkSelectableFg" :reserve-selection="true" type="selection" width="40"/>
            <el-table-column
                v-for="(item, index) in table_columns_admin"
                :key="item.key"
                :label="item.key"
                :prop="item.value"
                label="Date"
                :width="handleClickSelectWidth(item)"
                :min-width="handleClickSelectMinWidth(item)"
            >
              <!--              :show-overflow-tooltip="item.value==='customerName'||item.value==='customerCode'||item.value==='customerOrigin'?true:false"-->
              <!-- 分管特殊处理 -->
              <template #default="{ row, column, $index }">
                <template v-if="item.value === 'manageId'">
                  <div class="hover" v-if="row.mangerVOList&&row.mangerVOList.length > 0">
                    <div
                        :ref="ref => (refMap[row.customerCode] = ref)"
                    >
                      <!-- 触发内容1 -->
                      <el-button size="small" link type="primary"
                                 @mouseover="handleRef(refMap[row.customerCode], row, 2)">
                        {{ row.mangerVOList && row.mangerVOList.length }}
                      </el-button>
                    </div>
                  </div>
                  <template v-else>
                    <el-button size="small" link type="info">
                      {{ row.mangerVOList && row.mangerVOList.length }}
                    </el-button>
                  </template>
                </template>
                <template v-else-if="item.value === 'maiContactVOList'">
                  <div class="hover" v-if="row.maiContactVOList&&row.maiContactVOList.length > 0">
                    <div
                        :ref="ref => (refMap[row.id] = ref)"
                    >
                      <!-- 触发内容1 -->
                      <el-button size="small" link type="primary"
                                 @mouseover="handleRef(refMap[row.id], row, 1)">
                        {{ row.maiContactVOList.length }}
                      </el-button>
                    </div>
                  </div>
                  <div v-else>
                    <el-button size="small" link type="info">
                      {{ row.maiContactVOList && row.maiContactVOList.length }}
                    </el-button>
                  </div>
                </template>
                <template v-else-if="item.value ==='lastTime'">
                  <!--                  <div>{{ row.lastTime ? row.lastTime.split(' ')[0] : row.lastTime }}</div>-->
                  <!--                  <div>{{ row.lastTime ? row.lastTime.split(' ')[1] : row.lastTime }}</div>-->
                  <div>{{ row.lastTime }}</div>
                </template>
                <template v-else-if="item.value ==='zoneAddress'">
                  <div
                      :ref="ref => (refMap[`${row.id}_img_setting_address`] = ref)"
                      @mouseover="handleRef(refMap[`${row.id}_img_setting_address`], row, 3)"
                      v-if="row.zoneAddress"
                      style="cursor: pointer"
                  >
                    <!-- 触发内容1 -->
                    <el-image :src="flag[row.zoneCode]"
                              style="width:26px;margin-right:2px;vertical-align: middle;" :key="row.zoneCode" lazy/>
                  </div>
                </template>
                <template v-else-if="item.value==='customerName'">
                  <div :ref="el => setRef(el, row)"
                       class="over_text"
                       :key="row.customerName"
                       @mouseenter="handleMouseEnter(row)"
                       @click.native.stop="toDetail(row)">
                    {{ row.customerName }}
                  </div>
                </template>
                <template v-else-if="item.value==='customerCode'">
                  <div :ref="ref => (refMap[`${row.id}_code_setting`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_code_setting`], row, 5)"
                       v-if=" getTextLength(row.customerCode) > sizeMaxNumber"
                       class="over_normal"
                       :key="row.customerCode">
                    {{
                      getTextLength(row.customerCode) > sizeMaxNumber ? formatText(row.customerCode, sizeMaxNumber) : row.customerCode
                    }}
                  </div>
                  <div v-else>
                    {{ row.customerCode }}
                  </div>
                </template>
                <template v-else-if="item.value==='customerOrigin'">
                  <div :ref="ref => (refMap[`${row.id}_source`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_source`], row, 6)"
                       v-if="getTextLength(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='')[0]?.name) > sizeMaxNumber"
                       class="over_normal"
                       :key="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name">
                    <el-tag type="info"
                            v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length!==0">
                      {{
                        getTextLength(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name) > sizeMaxNumber
                            ? formatText(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name, sizeMaxNumber, true)
                            : row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name
                      }}
                    </el-tag>
                    <template v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length>1">
                      +{{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '').length - 1 }}
                    </template>
                  </div>
                  <div v-else class="over_normal">
                    <el-tag type="info"
                            v-if="row?.mailCustomerOriginDetailVoList&&row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length!==0">
                      {{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name }}
                    </el-tag>
                    <template v-else></template>
                    <template v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length>1">
                      +{{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== "").length - 1 }}
                    </template>
                  </div>
                </template>
                <template v-else-if="item.value==='customerIntention'">
                  <!--          {{ getTextLength(row?.mailLabelVoList.filter(item => item.type === 1)[0]?.name) }}-->
                  <div :ref="ref => (refMap[`${row.id}_product`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_product`], row, 9)"
                       v-if="getTextLength(row?.mailProductDetailVoList?.filter(it => it.name !=='')[0]?.name) > sizeMaxNumber"
                       class="over_normal"
                       :key="row?.mailProductDetailVoList?.filter(it => it.name!=='')[0]?.name">
                    <el-tag type="info" v-if="row?.mailProductDetailVoList?.filter(it => it.name !=='').length!==0">
                      {{
                        getTextLength(row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name) > sizeMaxNumber
                            ? formatText(row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name, sizeMaxNumber, true)
                            : row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name
                      }}
                    </el-tag>
                    <template v-if="row?.mailProductDetailVoList?.filter(it => it.name !=='').length>1">
                      +{{ row?.mailProductDetailVoList?.filter(it => it.name !== '').length - 1 }}
                    </template>
                  </div>
                  <div v-else class="over_normal">
                    <el-tag type="info"
                            v-if="row?.mailProductDetailVoList&&row?.mailProductDetailVoList?.filter(it => it.name!=='').length!==0">
                      {{ row?.mailProductDetailVoList?.filter(it => it.name !== "")[0]?.name }}
                    </el-tag>
                    <template v-else></template>
                    <template v-if="row?.mailProductDetailVoList?.filter(it => it.name !== '').length>1">
                      +{{ row?.mailProductDetailVoList?.filter(it => it.name !== '').length - 1 }}
                    </template>
                  </div>
                </template>
                <template v-else-if="item.value==='customerType'">
                  <div :ref="ref => (refMap[`${row.id}_customer_type_setting`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_customer_type_setting`], row, 7)"
                       v-if="getTextLength(row.customerType) > sizeMaxNumber"
                       :key="row.customerType"
                       class="over_normal">
                    {{
                      getTextLength(row.customerType) > sizeMaxNumber ? formatText(row.customerType, sizeMaxNumber) : row.customerType
                    }}
                  </div>
                  <div v-else class="over_normal">
                    {{ row.customerType }}
                  </div>
                </template>
                <template v-else-if="item.value==='createName'">
                  <div :ref="ref => (refMap[`${row.id}_create_name`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_create_name`], row, 8)"
                       v-if="getTextLength(row.createName) > sizeMaxNumber"
                       class="over_normal"
                       :key="row.createName">
                    {{
                      getTextLength(row.createName) > sizeMaxNumber ? formatText(row.createName, sizeMaxNumber) : row.createName
                    }}
                  </div>
                  <div v-else class="over_normal">
                    {{ row.createName }}
                  </div>
                </template>
              </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column :label="$t('common.cz')" :width="lang==='en'?300:180">
              <template #default="{ row, column, $index }">
                <el-button
                    link
                    size="small"
                    type="primary"
                    @click.stop="handleClickTargetData(row)"
                >{{ $t('common.archives') }}
                </el-button
                >
                <el-button
                    link
                    size="small"
                    type="primary"
                    @click.stop="handleClickBran(row)"
                >{{ $t('common.branch') }}
                </el-button
                >
                <ConfirmDeletePopover
                    :visible="row.popoverVisibleRemove"
                    :width="164"
                    :message="$t('common.cds1')"
                    @update:visible="(value) => (row.popoverVisibleRemove = value)"
                    @confirm:delete="deleteRow(row, column, $index)"
                >
                  <template #settings>
                    <el-button
                        link
                        size="small"
                        type="primary"
                        @click.stop="row.popoverVisibleRemove = true"
                    >{{ $t('common.move.to.seas') }}
                    </el-button
                    >
                  </template>
                </ConfirmDeletePopover>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
            </template>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pages">
          <Pagination v-model:modelValue="current"
                      v-model:pageSizeValue="size"
                      :total="totals"
                      v-if="totals"
                      ref="PaginationZQ"
                      @change="handleCurrentChange"
                      @checkAllItemPage="checkAllItemPage"
                      @unCheckAllItemPage="unCheckAllItemPage"
                      @getSelect="getSelectValue"
                      :multipleSelection="multipleSelection"
                      :isShowSelect="true"
          ></Pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane lazy name="4" style="padding: 6px !important;" :label="$t('common.customer.receive.examine')"
                   v-if="isSuperAdmin||isAdmin">
        <template #label>
          {{ $t('common.customer.receive.examine') }}
          <el-badge
              v-if="myEmailList.length>0 && myEmailList[4].count !== 0"
              :value="myEmailList[4].count"
              class="item"
              type="danger"
          ></el-badge>
        </template>
        <div>
          <!-- heander -->
          <div class="top_tips">
            <h2 style="font-weight: 500;font-size: 16px !important;">{{ $t('common.customer.receive.examine') }}</h2>
            <div>
              <el-button
                  type="primary"
                  size="small"
                  @click="clickPass"
                  :icon="Check"
              >{{ $t('common.pass') }}
              </el-button>
              <!--              <ConfirmDeletePopover-->
              <!--                  :visible="popoverVisibleReject"-->
              <!--                  :width="164"-->
              <!--                  :message="$t('common.cds10')"-->
              <!--                  @update:visible="(value) => (popoverVisibleReject = value)"-->
              <!--                  @confirm:delete="handleRejectList(row, column, $index)"-->
              <!--              >-->
              <!--                <template #settings="{ row, column, $index }">-->
              <!--                </template>-->
              <!--              </ConfirmDeletePopover>-->
              <el-button
                  size="small"
                  type="danger"
                  :icon="Close"
                  @click="clickReject"
              >{{ $t('common.reject') }}
              </el-button>
            </div>
          </div>
          <!-- 审批表 -->
          <el-table
              v-loading="isLoading"
              :data="allAdminList"
              style="width: 100%;margin-top: 20px"
              ref="targetTableAll"
              @selection-change="handleSelectionChangeAdmin"
              @select="handleCheck"
              @select-all="handleClickSelectAll"
              :cell-style="rowClassName"
              :header-cell-style="headerClassName"
              :row-key="row => row.id"
              @cell-mouse-leave="clearVisiblePopover"
          >
            <!--              @row-click="handleClickTargetData"-->
            <el-table-column :selectable="checkSelectableSP" :reserve-selection="true" type="selection" width="40"/>
            <el-table-column
                v-for="(item, index) in table_columns_required"
                :key="item.key"
                :label="item.key"
                :prop="item.value"
                label="Date"
                :width="handleClickSelectWidth(item,'admin')"
                :min-width="handleClickSelectMinWidth(item)"
            >
              <!--              :show-overflow-tooltip="item.value==='customerName'||item.value==='customerCode'||item.value==='customerOrigin'?true:false"-->
              <template #default="{ row, column, $index }">
                <template v-if="item.value ==='maiContactVOList'">
                  <div class="hover" v-if="row.maiContactVOList&&row.maiContactVOList.length > 0">
                    <div
                        :ref="ref => (refMap[row.id] = ref)"
                    >
                      <!-- 触发内容1 -->
                      <el-button size="small" link type="primary" @mouseover="handleRef(refMap[row.id], row, 1)">
                        {{ row.maiContactVOList && row.maiContactVOList.length }}
                      </el-button>
                    </div>
                  </div>
                  <div v-else>
                    <el-button size="small" link type="info">
                      {{ row.maiContactVOList && row.maiContactVOList.length }}
                    </el-button>
                  </div>
                </template>
                <template v-else-if="item.value==='customerCode'">
                  <div :ref="ref => (refMap[`${row.id}_s_code`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_s_code`], row, 5)"
                       v-if=" getTextLength(row.customerCode) > sizeMaxNumber"
                       class="over_normal"
                       :key="row.customerCode">
                    {{
                      getTextLength(row.customerCode) > sizeMaxNumber ? formatText(row.customerCode, sizeMaxNumber) : row.customerCode
                    }}
                  </div>
                  <div v-else class="over_normal">
                    {{ row.customerCode }}
                  </div>
                </template>
                <template v-else-if="item.value === 'customerName'">
                  <div :ref="el => setRef(el, row)"
                       class="over_text"
                       :key="row.customerName"
                       @mouseenter="handleMouseEnter(row)"
                       @click.native.stop="toDetail(row)">
                    {{ row.customerName }}
                  </div>
                </template>
                <template v-else-if="item.value==='customerOrigin'">
                  <div :ref="ref => (refMap[`${row.id}_source`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_source`], row, 6)"
                       v-if="getTextLength(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='')[0]?.name) > sizeMaxNumber"
                       class="over_normal"
                       :key="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name">
                    <el-tag type="info"
                            v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length!==0">
                      {{
                        getTextLength(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name) > sizeMaxNumber
                            ? formatText(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name, sizeMaxNumber, true)
                            : row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name
                      }}
                    </el-tag>
                    <template v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length>1">
                      +{{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '').length - 1 }}
                    </template>
                  </div>
                  <div v-else class="over_normal">
                    <el-tag type="info"
                            v-if="row?.mailCustomerOriginDetailVoList&&row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length!==0">
                      {{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name }}
                    </el-tag>
                    <template v-else></template>
                    <template v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length>1">
                      +{{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== "").length - 1 }}
                    </template>
                  </div>
                </template>
                <template v-else-if="item.value==='customerIntention'">
                  <!--          {{ getTextLength(row?.mailLabelVoList.filter(item => item.type === 1)[0]?.name) }}-->
                  <div :ref="ref => (refMap[`${row.id}_product`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_product`], row, 9)"
                       v-if="getTextLength(row?.mailProductDetailVoList?.filter(it => it.name !=='')[0]?.name) > sizeMaxNumber"
                       class="over_normal"
                       :key="row?.mailProductDetailVoList?.filter(it => it.name!=='')[0]?.name">
                    <el-tag type="info" v-if="row?.mailProductDetailVoList?.filter(it => it.name !=='').length!==0">
                      {{
                        getTextLength(row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name) > sizeMaxNumber
                            ? formatText(row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name, sizeMaxNumber, true)
                            : row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name
                      }}
                    </el-tag>
                    <template v-if="row?.mailProductDetailVoList?.filter(it => it.name !=='').length>1">
                      +{{ row?.mailProductDetailVoList?.filter(it => it.name !== '').length - 1 }}
                    </template>
                  </div>
                  <div v-else class="over_normal">
                    <el-tag type="info"
                            v-if="row?.mailProductDetailVoList&&row?.mailProductDetailVoList?.filter(it => it.name!=='').length!==0">
                      {{ row?.mailProductDetailVoList?.filter(it => it.name !== "")[0]?.name }}
                    </el-tag>
                    <template v-else></template>
                    <template v-if="row?.mailProductDetailVoList?.filter(it => it.name !== '').length>1">
                      +{{ row?.mailProductDetailVoList?.filter(it => it.name !== '').length - 1 }}
                    </template>
                  </div>
                </template>
                <template v-else-if="item.value ==='zoneAddress'">
                  <div style="cursor: pointer;">
                    <!-- 触发内容1 -->
                    <el-image :ref="ref => (refMap[`${row.id}_list_img`] = ref)"
                              @mouseover.stop="handleRef(refMap[`${row.id}_list_img`], row, 3)"
                              v-if="row.zoneAddress"
                              :src="flag[row.zoneCode]"
                              style="width:26px;height:20px;margin-right:2px;vertical-align: middle;"
                              :key="row.zoneCode"
                              lazy
                    />
                  </div>
                </template>
                <template v-else-if="item.value === 'customerType'">
                  <div :ref="ref => (refMap[`${row.id}_s_type`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_s_type`], row, 7)"
                       v-if="getTextLength(row.customerType) > sizeMaxNumber"
                       :key="row.customerType"
                       class="over_normal">
                    {{
                      getTextLength(row.customerType) > sizeMaxNumber ? formatText(row.customerType, sizeMaxNumber) : row.customerType
                    }}
                  </div>
                  <div v-else class="over_normal">
                    {{ row.customerType }}
                  </div>
                </template>
                <template v-else-if="item.value === 'customerLevel'">
                  <el-button link type="primary">
                    {{ row.customerLevel }}
                  </el-button>
                </template>
                <template v-else-if="item.value ==='lastTime'">
                  <div>{{ row.lastTime }}</div>
                </template>
                <template v-else-if="item.value==='createName'">
                  <div :ref="ref => (refMap[`${row.id}_create_name`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_create_name`], row, 8)"
                       v-if="getTextLength(row.createName) > sizeMaxNumber"
                       class="over_normal"
                       :key="row.createName">
                    {{
                      getTextLength(row.createName) > sizeMaxNumber ? formatText(row.createName, sizeMaxNumber) : row.createName
                    }}
                  </div>
                  <div v-else class="over_normal">
                    {{ row.createName }}
                  </div>
                </template>
                <template v-else-if="item.value==='userName'">
                  <div :ref="ref => (refMap[`${row.id}_user_name`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_user_name`], row, 9)"
                       v-if="getTextLength(row.userName) > sizeMaxNumber"
                       class="over_normal"
                       :key="row.userName">
                    {{
                      getTextLength(row.userName) > sizeMaxNumber ? formatText(row.userName, sizeMaxNumber) : row.userName
                    }}
                  </div>
                  <div v-else class="over_normal">
                    {{ row.userName }}
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.cz')" :width="lang !== 'zh-CN' ? 180 : 120" fixed="right">
              <template #default="{ row, column, $index }">
                <ConfirmDeletePopover
                    :visible="row.popoverVisiblePass"
                    :width="164"
                    :message="$t('common.cds9')"
                    @update:visible="(value) => (row.popoverVisiblePass = value)"
                    @confirm:delete="passCheck(row, column, $index)"
                >
                  <template #settings>
                    <el-button
                        link
                        type="primary"
                        @click.native.stop="row.popoverVisiblePass = true"
                    >{{ $t('common.pass') }}
                    </el-button
                    >
                  </template>
                </ConfirmDeletePopover>
                <ConfirmDeletePopover
                    :visible="row.popoverVisibleReject"
                    :width="164"
                    :message="$t('common.cds10')"
                    :ref="`popover-${$index}`"
                    @update:visible="
                    (value) => (row.popoverVisibleReject = value)
                  "
                    @confirm:delete="handleReject(row, column, $index)"
                >
                  <template #settings>
                    <el-button
                        link
                        type="danger"
                        @click.native.stop="row.popoverVisibleReject = true"
                    >{{ $t('common.reject') }}
                    </el-button
                    >
                  </template>
                </ConfirmDeletePopover>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
            </template>
          </el-table>
        </div>
        <div class="pages">
          <Pagination v-model:modelValue="currentList"
                      v-model:pageSizeValue="sizeList"
                      :total="totalsList"
                      v-if="totalsList"
                      ref="PaginationZQ2"
                      @change="handleCurrentChange"
                      @checkAllItemPage="checkAllItemPage"
                      @unCheckAllItemPage="unCheckAllItemPage"
                      @getSelect="getSelectValue"
                      :multipleSelection="multipleSelection"
                      :isShowSelect="true"
          ></Pagination>
        </div>
      </el-tab-pane>
      <!--      <el-tab-pane lazy :label="$t('common.customer.number.update')" name="5" v-if="isSuperAdmin">-->
      <!--        <el-row :gutter="24">-->
      <!--          <el-col :span="8">-->
      <!--            <el-form-->
      <!--                ref="ruleFormRef"-->
      <!--                style="margin-top: 10px"-->
      <!--                :model="ruleForm"-->
      <!--                label-width="120px"-->
      <!--                class="ruleFormInput"-->
      <!--            >-->
      <!--              <el-form-item style="margin-bottom: 20px;font-size: 14px;font-weight: normal"-->
      <!--                            :label="$t('common.customer.number.old')"-->
      <!--                            prop="oldClientNumber">-->
      <!--                <el-input size="small" v-model="ruleForm.oldClientNumber"/>-->
      <!--              </el-form-item>-->
      <!--              <el-form-item style="margin-bottom: 20px" :label="$t('common.customer.number.new')"-->
      <!--                            prop="newClientNumber">-->
      <!--                <el-input size="small" v-model="ruleForm.newClientNumber"/>-->
      <!--              </el-form-item>-->
      <!--              <el-form-item>-->
      <!--                <el-button size="small" type="primary" style="margin-top: 15px" @click="submitForm(ruleFormRef)"-->
      <!--                >{{ $t('common.confirm') }}-->
      <!--                </el-button-->
      <!--                >-->
      <!--              </el-form-item>-->
      <!--            </el-form>-->
      <!--          </el-col>-->
      <!--        </el-row>-->
      <!--      </el-tab-pane>-->
      <el-tab-pane
          lazy
          v-if="isSuperAdmin"
          :label="$t('common.customer.batchhandover')"
          name="6"
          style="padding: 6px !important;"
      >
        <MyAlert :textInner="alert1"/>
        <div style="margin: 10px">
          <el-form
              ref="ruleFormRemove"
              :model="ruleFormTabAB"
              class="demo-ruleForm"
          >
            <div class="top">
              <el-form-item :label="`${$t('common.salesman')} A`">
                <el-select
                    size="small"
                    :placeholder="$t('common.please.select')"
                    style="width: 200px"
                    filterable
                    v-model="ruleFormTabAB.A"
                    popper-class="my-select_sp"
                >
                  <el-option
                      v-for="item in tableDataSelect"
                      :label="item.userName"
                      :value="item.userId"
                      :key="item.id"
                  />
                </el-select>
              </el-form-item>
              <el-image
                  style="width: 30px; height: 30px; margin: 0px 20px 0 20px"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABFhJREFUWEftll1oW2UYx39Pktraba6dXZOU4aYou5nOj3rRDURR8VYExxA/mYIWaU46S5HqqO1Q5+aaTJ2KTNyHc8yJIl4o24XCNiZOEXcxOnXKbM3pFFuELkWT88hJky5Ncr6kBS88V8k5//d5fu/z8T6v8B97ZL55YkO6gjCNkRw/jXRL1svfvAFFU7pBlGcRlhchsiK8O5mn989u+cMJbF6AYil9CehxcDp8wWKNE9ScA8VTeovCF66pEd42E7KhlmbOgWJp3YPygEetTOnftIz1yGSlbu6BUvo1cKNX8Vqw+rwh3/1roEK3wK0CSzTESCTPkZEaxRlN6zFR1ngB5SKs/P1JORMYqPlNXdyQZafCeiBUZiCLsMUcZ5B+sUrvoykdFHjGA+hXM8EyRDQQ0NLXdGEkx1FVVrs42GMa8lDp++Kd2nzpX/wALHFsbeGJTELeCFzU8ZRuV0h6hR/lXjMph0q6+Cvarnk+BS6vWqs8ZyalP/g5tEPrYxa/AYs8geBz05DbynVtKV2ZhwMC1xffjws8ljHkAzd7jl3WtkNvsCy+8QFjS7KmIY32j/irulxzDKCsR7ikYn0eOCxKXyYpNW07ArUO6dqQcNQnkGVOUBdv4j4FuzYWeKyzEAbMLgYqC9sRKLpVW6UOE/A8qwS+B15XeNmPfgZW2G0meAQudpurs+iQHhbhDs8oCadQVgWCKRkVBs2EbLr418VbNK2rUI4JXOYisyf3QqiqF8992AKFvECHachX9n/PdBRb+BMgWsPDSYSzKOvKvuUVVCDii8iGEo6PJWStLyBbtDSt14SV/UB70Ymq8JYqm0JwFmi0d4pwIBxis5XnM+AKv0CFSIXoGOuSE64Riqf1JlUGgbsqxsa0L2FKlYgI7+XCbC7NpnhaH9fKNCt9uKReIJUxJFkb6KCGYxleRNnokdbT4Tx3j26sHpKV0YmldRSlzTFqwikzIddVAa3o14ZsEx8L3Okn5ArfivCCOc6h0pCNb9d2EerL11vCR0CLC9AFMyELZgP1ayjWxPvAPX5gZmmEMypsGatnbyxbGK6Basi2la9j0SygWFqfQtnqF0ZhPyG+xKJXmEnHueJQ9Tqtq9w0KM0zQNEhvUpChQOuMJNqPMMIR8rfi3IiY8g+O81TTTwK9ALL/G6oUjcLKJ5Wu41tozUfhX1jhrjfle0bgm1DCw1hX2V/DgIXaqSzEKG2bdpiRfgFaHAB+jASoqv8ezjC5LlOGS+8O6jh6CjrBJ5GuFZgV8YQxw06+SkAxVN6v8LeILuZPobYlZmgM9rMg6KFdF1dZmPcnKCVfskFsVsAig3pOwgz19AABk4XL3A160Ysbs50y8kA9qZnWSylx4GOIAt9aYWHzYTs9qUtikpA9jy6MshCX1qlx0zKNl/aCiD7IlZrmgexVaUV6MsY8nwQI6UI/Q/k2vbRtN4uzB6GQcLspLWE4fNd8mMQW543xiDG5kL7D3n/dCF/GHS6AAAAAElFTkSuQmCC"
                  :fit="fit"
              />
              <el-form-item :label="`${$t('common.salesman')} B`">
                <el-select
                    size="small"
                    :placeholder="$t('common.please.select')"
                    style="width: 200px"
                    filterable
                    v-model="ruleFormTabAB.B"
                >
                  <el-option
                      v-for="item in tableDataSelect"
                      :label="item.userName"
                      :value="item.userId"
                      :key="item.id"
                  />
                </el-select>
              </el-form-item>
            </div>
            <div class="bottom">
              <el-form-item>
                <el-button size="small" @click="changeTransfer" type="primary">{{
                    $t("common.confirm")
                  }}
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane
          :label="$t('common.customer.merge')"
          name="7"
          style="padding: 6px !important;"
          v-if="isSuperAdmin"
      >
        <MyAlert :textInner="alert2"/>
        <div>
          <el-form
              ref="ruleFormRemove"
              :model="ruleFormTabABMerge"
              class="demo-ruleForm"
          >
            <div class="top">
              <el-form-item :label="$t('common.customer')+'A'">
                <CustomerSelect
                    v-model="ruleFormTabABMerge.A"
                    :teamId="teamId"
                    class="customerSelectRef"
                    ref="customerSelectRefA"
                />
              </el-form-item>
              <el-image
                  style="width: 32px; height: 32px; margin: 0px 20px 0 20px"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABQNJREFUWEftlmuIlGUUx3/nnV1dxbzrvKPdtFI0irKwPihRKShWopUQ5gUqJbTd2VDK/LKU1oewnVlRMQmLykhLQSsJUqI7gl3IMCNNRXdmXNRVvKy7M+8/3nVnfXecdWbUD37wwDC85/mf8/w4z3kuxjVmdo3xcB2o0Ipcr9CVVahGZZG+zJfHZDPSHmxORVjJNMsUSpwdH/ym+nndeUswATgDfJpsZCk11pwvxyWXzI3pA2BmMNBgXSJq04sCqlNXV3yHGJ2j35CM2rSSgAbENCYE3+cL8sSYI9X2YyGoSJ2my+OjfDrHYVR9pf2WO9ZphcJxVZmI5UsmozJVZcsLAYVjWmrwWic5pqeqbF3RQG6tnsLYkLesxtRElW0qBOTWajbG2rw5xH2Javu1aCDq1DUi/pS4IydoT7KRuztryqD21rWqaDrB78DwnBxfJKP2eEk95IsHL9OwTIjPZfyB6G5wi6WZmlhgBwpVJzs+oFb3hBw+BrZJ9DMY0uww4VilnSwe6PzuqEJEgQjGV8ABxItmfOM5zEm9ZP9dCir8tgY65bwumA109bc7ohljBvCXlTEzMb+IJRsU03AP/P4Y0T6hsRBoQLzf5jsqMS1VbdvzQUXqNFYenwEDA+OzJLqYsabNd1biuVS1fZJzrFz47F+rSMjYaX5VAuaEGJFJ02zG3oC7yRHj6nO2f2SFRqiFHUCPgNbDwQ210CcTYk/WL8iYw+RkpX2Z9XXY9pG41kg8H4QR/JuKWmtju3EdRgwKjO9LNjKcGktnfeG4NpqY0qFyYkey2h5ozRFTfWsbXLBERSND99dYk+/qAOTGtA8YkrMMR81jildGCx5bDXrnTPZwstq+zfrcuBIINyfHKTNmetDVhH/6dwmOZ2BsQ9R+uAgoEtcMiVcwRqIA7Plm9KvQvb3cIu03OLT+JgJhYLfBXsGD0HpdtOsBry3WafsXsN8/68oy1Bx62c5eBJSdrM9q9apo4nZBWNDTPCpwMM9oNjjpiPp0GXucFt4wWndiuwlaHHgmEWXjgBWErYWBiBscKPdFCtEUaqaxpRuHGubZqZxKXqjCgBXq0dBAU7AfcsXB70itRsnY2YnmqNONm+vnmn+7F7S+deqZPZdae6j/Mg3rEmJsfdTeKxjdJgjHtdjEks70EuNT1eYvZ0ELx/SEL0pFbbO5yzWRNIuSIcZTaecKRl8AWmJicad6Y1KyyvwDtbA9rZA7hl0Sq8yNyW/WUOGoDgoPYxViXidxZ9PitjL4GuOuUnL7QH63l2p702JsCFaZMfmiYGNh8jjvuL1ZDzxZSvIreuT3Wqk+Fc1s8be6Gf9ITAJ+SkZtQSkQQe1lAQ1are7eORbgUQn0a01oPILYjiHEpkw58xrmWbJUsJKBIst1vzzWow4n+u5k1Ea6tTqIcVMbRMoTU45U28+lQJUE5NZpNB7bci5Of75l/jKFY/rQ4NkAwGk5jEtV2i/FQhUPtFrl7ln+BobmJpd41H+KRGJ6QfBucFxwuLmJO4+/aieKgSoaKBzTYwZb8iT1MuUM9vvFrdNDeLRftAHtgmTUll1VIDeuWYEHWm5u/520SBDPfUud73fWJKI256oCUSPH7cMs85gs417gRiB7c+eb6xTGLsTWc92IH597lZfsohlXq7z/Gfpj9HQyVJSV46Q9MjicrjjNsYOL7HgxFcnVFN1Dl5P8cmKuOaD/AW4e15QUdPS6AAAAAElFTkSuQmCC"
                  :fit="fit"
              />
              <el-form-item :label="$t('common.customer')+'B'">
                <CustomerSelect
                    v-model="ruleFormTabABMerge.B"
                    :teamId="teamId"
                    ref="customerSelectRefB"
                />
              </el-form-item>
            </div>
            <div class="bottom">
              <el-form-item>
                <el-button size="small" @click="changeMerge" type="primary">{{
                    $t("common.confirm")
                  }}
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
  <!--批量分管-->
  <Dialog
      v-model="dialogVisibleBranch"
      :title="$t('common.branch.setting')"
      :dialogVisible="dialogVisibleBranch"
      :isHeadLine="false"
      :width="400"
      align-center
      @update:dialogVisible="(val) => (dialogVisibleBranch = val)"
  >
    <template #content>
      <el-checkbox-group v-model="checkListBranch">
        <el-checkbox
            v-for="item in tableDataSelect"
            :label="JSON.stringify({manageId: item.userId, userName: item.userName})"
            :key="item.id"
        >{{ item.userName }}
        </el-checkbox
        >
      </el-checkbox-group>
    </template>
    <template #footer>
      <div class="buttons_bottom">
        <el-button size="small" @click="dialogVisibleBranch = false">{{ $t('common.sss16') }}</el-button>
        <el-button size="small" type="primary" @click="handleClickSubmit" :loading="isLoadingBranch">
          {{ $t('common.confirm') }}
        </el-button>
      </div>
    </template>
  </Dialog>
  <!--  el-popover-->
  <el-popover
      v-model:visible="visiblePopover"
      :virtual-ref="tempRef"
      virtual-triggering
      trigger="hover"
      placement="right"
      effect="dark"
      :popper-style="{ minWidth: '60px', width: 'auto' }"
  >
    <template v-if="popoverType === 1">
      <div class="popover-content">
        <div
            v-for="(item, index) in activeItemElpopover.maiContactVOList"
            :key="index"
        >
          {{ item.contactName }}
        </div>
      </div>
    </template>

    <template v-else-if="popoverType === 2">
      <div class="popover-content">
        <div
            v-for="(item, index) in activeItemElpopover.mangerVOList"
            :key="index"
        >
          {{ item.managerName }}
        </div>
      </div>
    </template>

    <template v-else-if="popoverType === 3">
      <div class="popover-content">
        {{ activeItemElpopover.zoneAddress }}
      </div>
    </template>

    <template v-else-if="popoverType === 4">
      <div class="popover-content">
        {{ activeItemElpopover.customerName }}
      </div>
    </template>

    <template v-else-if="popoverType === 5">
      <div class="popover-content">
        {{ activeItemElpopover.customerCode }}
      </div>
    </template>

    <template v-else-if="popoverType === 6">
      <div class="popover-content">
        {{ activeItemElpopover?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0].name }}
      </div>
    </template>

    <template v-else-if="popoverType === 7">
      <div class="popover-content">
        {{ activeItemElpopover.customerType }}
      </div>
    </template>

    <template v-else-if="popoverType === 8">
      <div class="popover-content">
        {{ activeItemElpopover.createName }}
      </div>
    </template>

    <template v-else-if="popoverType === 9">
      <div class="popover-content">
        {{ activeItemElpopover.userName }}
      </div>
    </template>
    <template v-else-if="popoverType === 10">
      <div class="popover-content">
        {{ activeItemElpopover?.mailProductDetailVoList?.filter(it => it.name !== '')[0].name }}
      </div>
    </template>
  </el-popover>
  <!-- 抽屉 -->
  <el-drawer size="530px" v-model="isShowDrawers" :direction="direction" style="padding: 15px 5px 15px 10px">
    <template #header>
      <div style="display: flex;align-items: center">
        <h4 style="color: rgba(0, 0, 0, .85);font-weight: 500;font-size: 16px;line-height: 22px;width: 410px">
          {{ activeItem.customerName }}</h4>
        <router-link
            :to="
            '/email/customer/detail/' +
            activeItem.id +
            '?tabKey=1&type=' +
            activeItem.type
          "
            style="color: #409eff"
        >
          <el-button v-if="isShowEdit" link type="primary">{{ $t('common.edit') }}</el-button>
        </router-link>
      </div>
    </template>
    <template #default>
      <div class="top_titles">
        <div>
          <div class="font_targert">{{ $t('common.customer.numberList') }}：{{ activeItem.customerCode }}</div>
          <div class="font_targert" style="margin: 10px 0px;">{{ $t('common.byinput') }}：{{
              activeItem.createName
            }}
          </div>
          <div class="font_targert" style="margin: 10px 0px;">{{
              $t("common.bybranch")
            }}：{{ activeItem.mangerVOList.map(item => item.managerName).join(',') }}
          </div>
          <div class="font_targert">
            {{ $t('sending.table.col.createTime') }}：{{ activeItem?.createTime }}
          </div>
        </div>
      </div>
      <div style="margin-top: 15px">
        <!-- table -->
        <div>
          <div class="customer_title">{{ $t('common.cds25') }}</div>
          <div class="small_box">
            <TableShows :table-data="companyInfo"/>
          </div>
        </div>
        <div style="margin-top: 15px">
          <div class="customer_title">{{ $t('common.marketing.information') }}</div>
          <div class="small_box">
            <TableShows :table-data="marketingInfo"/>
          </div>
        </div>
        <div style="margin-top: 15px">
          <div class="customer_title">{{ $t('common.contact') }}</div>
          <div
              class="small_box"
              v-for="(item, index) in contactInfo"
              :key="index"
          >
            <TableShows :table-data="item"/>
          </div>
        </div>
      </div>
    </template>
  </el-drawer>

  <!--  移动至公海-->
  <CustomerMovePublicSea v-if="popoverVisibleAll" v-model="popoverVisibleAll" @close="closePopoverVisibleAll"
                         :multipleSelection="multipleSelection" :getCustomerList="refreshTable"
                         :isSelectAll="isSelectAll" :searchValue="searchValue"
                         @public="handleDelete" :isLoadingMove="isLoadingMove"></CustomerMovePublicSea>
  <!--  pass-->
  <CustomerShPass v-if="popoverVisiblePass" v-model="popoverVisiblePass" @close="closePopoverVisiblePass"
                  :multipleSelection="multipleSelection" :getCustomerList="refreshTable"
                  :isSelectAll="isSelectAll" :searchValue="searchValue"
                  @public="handlePassList" :isLoadingMove="isLoadingPass"
                  :isLoadingPass="isLoadingPass"></CustomerShPass>
  <!--  reject-->
  <CustomerShReject v-if="popoverVisibleReject" v-model="popoverVisibleReject" @close="closePopoverVisibleReject"
                    :multipleSelection="multipleSelection" :getCustomerList="refreshTable"
                    :isSelectAll="isSelectAll" :searchValue="searchValue"
                    @public="handleRejectList" :isLoadingReject="isLoadingReject"></CustomerShReject>
</template>
<script setup>
import {ref, computed, onMounted, watch, nextTick, onBeforeUnmount, reactive} from "vue";
import Cards from "./Cards.vue";
import TopSearch from "./TopComponents/TopSearch.vue";
import MyAlert from "./TopComponents/MyAlert.vue";
import TableEditeInput from "./Tables/TableEditeInput.vue";
import {i18n} from "../../lang/index";
import FollowClient from "./Tables/FollowClient.vue";
import Dialog from "@/components/Dialog.vue";
import CustomerSelect from '../../components/CustomerSelect.vue';
import {useStore} from "vuex";
import {table_columns_admin, table_columns_required} from './map'
import {
  updateCustomerData,
  getMailCustomerList,
  getMailCustomerSetting,
  batchTransfer,
  batchTransferCustomer,
  getMailCustomerAudit,
  updateMailCustomerAudit, updateFollowUser,
  getFollowUser, requestAllCustomer
} from "@/api/customer.js";
import {ElMessage, ElTable} from "element-plus";
import TableShows from "./Tables/TableShows.vue";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import {debouncePlus, throttle} from "@/utils/mylodash"
import {emptyUrl, POPOVER_DELAY_TIME} from "@/utils/statusParams";
import flag from "@/assets/flag";
import {useRoute, useRouter} from "vue-router";
import {flexWidth} from "@/utils/tableWidth";
import {formatText, getTextLength, getTextWidth} from "@/utils/util";
import Pagination from "@/components/Pagination/index.vue";
import CustomerMovePublicSea from "@/components/DiaPops/CustomerMovePublicSea.vue";
import CustomerShPass from "@/components/DiaPops/CustomerShPass.vue";
import CustomerShReject from "@/components/DiaPops/CustomerShReject.vue";
import {Check, Close, Remove, UserFilled} from "@element-plus/icons-vue";
import LabelSetting from "@/views/components/labelSetting.vue";
import sessionStore from "@/utils/sessionStore";

const router = useRouter()
const route = useRoute()
const store = useStore();
const direction = ref("rtl");
// 跟进人list
const checkList = ref([]);
// 展示跟进人数据
const showCheckList = ref([])
const customerListAll = computed(() => store.state.customer.customerListAll)

// 客户分管table
const targetTable = ref(null)
const targetTableAll = ref(null)
// 权限控制
const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
const isAdmin = computed(() => store.getters["user/isAdmin"])
// 标记
const teamId = computed(() => store.state.email.teamID);

const customerSelectRefA = ref(null);
const customerSelectRefB = ref(null);

// el-popover 优化
const refMap = ref({})
const tempRef = ref();
const visiblePopover = ref(false)
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)
const handleRef = debouncePlus((ref, item, type) => {
  tempRef.value = ref
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)


const refreshTable = async () => {
  await resetInit()
  await getCustomerList()
}

// 更新跟进人列表
const updateFollowUsers = async () => {

  const result = JSON.parse(JSON.stringify(checkList.value));
  const toBaseObj = result.map(item => JSON.parse(item))
  const targetObj = {
    mailFollowAndUserDTOList: [...toBaseObj],
    teamId: teamId.value
  }
  //console.log(targetObj, toBaseObj)
  let res = await updateFollowUser({...targetObj})
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return
  }
  ElMessage.success(res.message)
  dialogVisible.value = false;
  await getFollowUserList()
};

//获取用户勾选状态
const getFollowUserList = async () => {
  let res = await getFollowUser({teamId: teamId.value})
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return
  }
  const stringArray = res.result.map(item => (JSON.stringify({id: item.id, userId: item.userId})));
  checkList.value = stringArray;
  showCheckList.value = res.result

}
const showDialog = async () => {
  await getFollowUserList()
  dialogVisible.value = true;
};

// 搜索
const searchValue = ref({});
const empty = ref(i18n.global.t('select.empty'))

const getSearchKey = async (value) => {
  const newObj = JSON.parse(JSON.stringify(value));
  if (newObj.customerOrigin === empty.value) {
    newObj.customerOrigin = ''
  }
  if (newObj.product === empty.value) {
    newObj.product = ''
  }
  if (newObj.customerTypeId === empty.value) {
    newObj.customerTypeId = ''
  }
  searchValue.value = newObj;
  // const tabCheck = localStorage.getItem("tabCheck");
  // activeName.value = isSuperAdmin.value ? tabCheck ? tabCheck : "1" : "3"
  if (activeName.value === "3") {
    // 列表数据
    await getCustomerList();
  }
};
// tab进行切换的时候
const handleClick = throttle(async (val) => {
  isSelectAll.value = false
  await resetInit()
  const tabs = val.props.name;
  console.log(tabs, 'tab')
  nextTick(() => {
    console.log(customerSelectRefA.value, 'customerSelectRef');
  });
  // localStorage.setItem("tabCheck", tabs);
  switch (tabs) {
    case "4":
      await getCustomerListAdmin();
      await store.dispatch('countshow/getTeamAllDataApis')
      break;
    case "2":
      await store.dispatch("groups/getAllUserList", {teamId: teamId.value});
      await getFollowUserList();
      // await getAllCustomer()
      nextTick(() => {
        customerSelectRefA.value?.initGetAllCustomer();
        // customerSelectRefB.value.initGetAllCustomer();
      });
      break;
    case "3":
      await store.dispatch("groups/getAllUserListNo", {teamId: teamId.value});
      // await getCustomerList();
      break;
    case "6":
      await store.dispatch("groups/getAllUserListNo", {teamId: teamId.value});
      break;
    case "1":
      if (!sessionStore.get("customerLevel")) {
        await store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value, isUpdate: true});
      }
      break;
    case "7":
      // await getAllCustomer()
      nextTick(() => {
        customerSelectRefA.value?.initGetAllCustomer();
        // customerSelectRefB.value.initGetAllCustomer();
      });
      break;
  }
}, 100);

watch(() => isSuperAdmin.value, () => {
  if (!isSuperAdmin.value) {
    // localStorage.setItem('activeMenu', '/email/inbox')
    router.push('/email/inbox')
  }
})


// 分管中的人
const tableDataSelect = computed(() => store.state.groups.AllTableDataNo);
//客户跟进 有权限
const AllTableData = computed(() => store.state.groups.AllTableData)
const contactList = computed(() => store.state.customer.contactList);

const dialogVisible = ref(false);

const ruleForm = ref({
  oldClientNumber: "",
  newClientNumber: "",
});

//客户批量移交
const ruleFormTabAB = ref({
  A: "",
  B: "",
});
//客户批量转交
const ruleFormTabABMerge = ref({
  A: "",
  B: "",
});
// alert1
const alert1 = [
  {text: i18n.global.t("other.text.customer.transfer.tip1")},
  {text: i18n.global.t("other.text.customer.transfer.tip2")},
];
const alert2 = [
  {text: i18n.global.t("other.text.customer.merge.tip1")},
  {text: i18n.global.t("other.text.customer.merge.tip2")},
];

// 默认选中的tab
const activeName = ref("1");

const ruleFormRef = ref(null);
const submitForm = () => {
  ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      const newObj = JSON.parse(JSON.stringify(ruleForm.value));
      const targetObj = {
        newCustomerCode: newObj.newClientNumber.toUpperCase(),
        oldCustomerCode: newObj.oldClientNumber.toUpperCase(),
        teamId: teamId.value
      };
      const res = await updateCustomerData({...targetObj});
      if (res.code !== 200) {
        ElMessage.error(res.message);
        return;
      }
      ElMessage.success(res.message);
      ruleFormRef.value.resetFields();
    } else {
      //console.log("error");
    }
  });
};

// 客户资料进行合并
const changeMerge = async () => {
  const targetObj = {
    newCustomerId: "",
    oldCustomerId: "",
    teamId: teamId.value,
  };
  targetObj.oldCustomerId = ruleFormTabABMerge.value.A;
  targetObj.newCustomerId = ruleFormTabABMerge.value.B;
  //console.log(targetObj);
  let res = await batchTransfer({...targetObj});
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return;
  }
  ElMessage.success(res.message);
  ruleFormTabABMerge.value.A = "";
  ruleFormTabABMerge.value.B = "";
};

// 客户批量移交
const changeTransfer = async () => {
  const targetObj = {
    newUserId: "",
    oldUserId: "",
    teamId: teamId.value,
  };
  targetObj.oldUserId = ruleFormTabAB.value.A;
  targetObj.newUserId = ruleFormTabAB.value.B;
  //console.log(targetObj, "fff");

  let res = await batchTransferCustomer({...targetObj});
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return;
  }
  ElMessage.success(res.message);
};

// 用于分页的客户
const customerList = ref([]);
// 所有客户--用于合并
// const customerListAll = ref([]);
const isLoading = ref(false);
const getCustomerList = async () => {
  isLoading.value = true;
  if (searchValue.value.managerId === "all") {
    searchValue.value.managerId = ""
  }
  await getMailCustomerList({
    ...searchValue.value,
    pageSize: size.value,
    pageNo: current.value,
    teamId: teamId.value,
    type: 1,
  }).then(async (res) => {
    const {records, size, total, pages} = res.result;
    customerList.value = records
    // visibleData.value = customerList.value.slice(0, 10)
    totals.value = total - 0;
    isLoading.value = false;
  });
};


// 客户审批-批量选中的值
const handleSelectionChangeAdmin = async (val) => {
  console.log(val, 'val')
  endIndex = val.length > 1 ? allAdminList.value.findIndex(item => item.id === val[val.length - 1].id) : -1;
  const startIndex = val.length > 1 ? allAdminList.value.findIndex(item => item.id === val[val.length - 2].id) : -1;
  console.log(endIndex, startIndex);
  if (isShiftPressed.value && val.length > 1 && endIndex !== startIndex) {
    const start = startIndex < endIndex ? startIndex : endIndex;
    const end = endIndex < startIndex ? startIndex : endIndex;
    // console.log(start, end, '===============');
    for (let i = start; i <= end; i++) {
      const row = allAdminList.value[i];
      if (start === i || i === end) {
        continue;
      }
      console.log(row, '更新');
      if (row) {
        targetTableAll.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
      }
    }
    nextTick(async () => {
      await store.commit("customer/setMultipleSelection", targetTableAll.value.getSelectionRows())
    });
  } else {
    await store.commit("customer/setMultipleSelection", val)
  }
};

// 通过？驳回？
const popoverVisiblePass = ref(false);
const popoverVisibleReject = ref(false);
const myEmailList = computed(() => store.state.countshow.myEmailList)
// 单行选中
const passCheck = async (row, column, $index) => {
  const {id, recordId, customerName, userId} = row;
  const targetObj = {
    auditStatus: 2,
    mailCustomerAndRecordIdDTOList: [{customerId: id, customerName, recordId, userId,}],
    teamId: teamId.value,
  };
  console.log('########', targetObj)
  let res = await updateMailCustomerAudit({...targetObj});
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return;
  }
  ElMessage.success(res.message);
  // 更新标志
  await store.dispatch('countshow/getTeamAllDataApis')
  await getCustomerListAdmin();
  await resetInit()
};
// 单行驳回
const handleReject = async (row, column, $index) => {
  const {id, recordId, customerName, userId} = row;
  const targetObj = {
    auditStatus: 3,
    mailCustomerAndRecordIdDTOList: [{customerId: id, customerName, recordId, userId}],
    teamId: teamId.value,
  };
  //console.log(targetObj, "@@@");
  let res = await updateMailCustomerAudit({...targetObj});
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return;
  }
  ElMessage.success(res.message);
  await getCustomerListAdmin();
  await resetInit()
};

// 点击批量通过
const clickPass = () => {
  if (multipleSelection.value.length === 0) {
    ElMessage.warning(i18n.global.t("common.email.chooseCustomer"));
    return;
  }
  popoverVisiblePass.value = true;
};
// 点击批量驳回
const clickReject = () => {
  if (multipleSelection.value.length === 0) {
    ElMessage.warning(i18n.global.t("common.email.chooseCustomer"));
    return;
  }
  popoverVisibleReject.value = true;
};
// 批量确认
const isLoadingPass = ref(false)
const closePopoverVisiblePass = () => {
  popoverVisiblePass.value = false
}
const handlePassList = async () => {
  const newObj = JSON.parse(JSON.stringify(multipleSelection.value));
  const result = newObj.map((item) => {
    return {customerId: item.id, customerName: item.customerName, recordId: item.recordId, userId: item.userId};
  });
  const targetObj = {
    auditStatus: 2,
    mailCustomerAndRecordIdDTOList: [...result],
    teamId: teamId.value,
    selectAll: isSelectAll.value,
    ...searchValue.value,
  };
  isLoadingPass.value = true
  let res = await updateMailCustomerAudit({...targetObj});
  if (res.code !== 200) {
    isLoadingPass.value = false
    ElMessage.error(res.message);
    return;
  }
  ElMessage.success(res.message);
  isLoadingPass.value = false
  closePopoverVisiblePass()
  await store.dispatch('countshow/getTeamAllDataApis')
  await getCustomerListAdmin();
  await resetInit()
};

const closePopoverVisibleReject = () => {
  popoverVisibleReject.value = false
}
const isLoadingReject = ref(false)

// 批量驳回
const handleRejectList = async () => {
  const newObj = JSON.parse(JSON.stringify(multipleSelection.value));
  const result = newObj.map((item) => {
    return {customerId: item.id, customerName: item.customerName, recordId: item.recordId, userId: item.userId};
  });
  const targetObj = {
    auditStatus: 3,
    mailCustomerAndRecordIdDTOList: [...result],
    teamId: teamId.value,
    selectAll: isSelectAll.value,
    ...searchValue.value,
  };
  isLoadingReject.value = true
  let res = await updateMailCustomerAudit({...targetObj});
  if (res.code !== 200) {
    ElMessage.error(res.message);
    isLoadingReject.value = false
    return;
  }
  ElMessage.success(res.message);
  isLoadingReject.value = false
  closePopoverVisibleReject()
  store.dispatch('countshow/getTeamAllDataApis')
  getCustomerListAdmin();
  resetInit()
};

// 客户分管-分页
const current = ref(1);
const size = ref(10);
const totals = ref(0);

function handleSizeChange(pageSize) {
  size.value = pageSize;
  getCustomerList();
}


function handleSizeChangeList(pageSize) {
  sizeList.value = pageSize;
  getCustomerListAdmin();
}

async function handleCurrentChange(page) {
  const {pageNo, pageSize} = page
  if (activeName.value === '3') {
    current.value = pageNo;
    size.value = pageSize;
    await getCustomerList();
  } else if (activeName.value === '4') {
    currentList.value = pageNo
    sizeList.value = pageSize
    await getCustomerListAdmin()
  }
  if (isSelectAll.value) {
    await getSelectValue()
  }
}

const isShow = ref(false);
const clickShowDraw = () => {
  isShow.value = !isShow.value;
};

// 分管对话框
const dialogVisibleBranch = ref(false);
// 选择的项
const checkListBranch = ref([]);
// 客户分管-批量选中的值
const multipleSelection = computed(() => store.state.customer.multipleSelection)
const handleSelectionChange = async (val) => {
  console.log(val, 'val')
  endIndex = val.length > 1 ? customerList.value.findIndex(item => item.id === val[val.length - 1].id) : -1;
  const startIndex = val.length > 1 ? customerList.value.findIndex(item => item.id === val[val.length - 2].id) : -1;
  console.log(endIndex, startIndex);
  if (isShiftPressed.value && val.length > 1 && endIndex !== startIndex) {
    const start = startIndex < endIndex ? startIndex : endIndex;
    const end = endIndex < startIndex ? startIndex : endIndex;
    // console.log(start, end, '===============');
    for (let i = start; i <= end; i++) {
      const row = customerList.value[i];
      if (start === i || i === end) {
        continue;
      }
      console.log(row, '更新');
      if (row) {
        targetTable.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
      }
    }
    nextTick(async () => {
      await store.commit("customer/setMultipleSelection", targetTable.value.getSelectionRows())
    });
  } else {
    await store.commit("customer/setMultipleSelection", val)
  }
};

const flags = ref(0);
// 批量设置分管
const handleClickBranch = () => {
  if (multipleSelection.value.length === 0) {
    ElMessage.warning(i18n.global.t("common.email.chooseCustomer"));
    return;
  }
  dialogVisibleBranch.value = true;
  flags.value = 1;
};
// 选中的行
const activeItem = computed(() => store.state.customer.ruleForm)
const handleClickBran = async (row) => {
  if (row) {
    // 这里要进行数据的显示
    const result = row.mangerVOList.map(item => JSON.stringify({manageId: item.managerId, userName: item.managerName}));
    checkListBranch.value = result;
    dialogVisibleBranch.value = true;
    activeItem.value = row;
    flags.value = 1;
  }
};
// 追加分管设置
const handleClickAppends = async () => {
  if (multipleSelection.value.length === 0) {
    ElMessage.warning(i18n.global.t("common.email.chooseCustomer"));
    return;
  }
  dialogVisibleBranch.value = true;
  flags.value = 3;
};
// 移入公海
const popoverVisibleAll = ref(false);
const handleClickRemove = async (row) => {
  if (multipleSelection.value.length === 0) {
    ElMessage.warning(i18n.global.t("common.email.chooseCustomer"));
    return;
  }
  popoverVisibleAll.value = true;
};
const closePopoverVisibleAll = () => {
  popoverVisibleAll.value = false
}

const isLoadingMove = ref(false)
// 单行 + 批量 移入公海
const handleDelete = async (row, column, $index) => {
  const targetObj = {
    customerDTOList: [],
    managerDTOList: [],
    teamId: teamId.value,
    type: 2,
    selectAll: isSelectAll.value,
    managerId: userInfo.value.id,
    ...searchValue.value,
  };
  const checkoutUsers = checkListBranch.value.map(item => JSON.parse(item))
  targetObj.managerDTOList = [
    ...targetObj.managerDTOList,
    ...checkoutUsers,
  ];
  let newObj = null;
  if (multipleSelection.value.length >= 1) {
    // 批量移入公海
    newObj = JSON.parse(JSON.stringify(multipleSelection.value));
    const result = newObj.map((item) => ({customerId: item.id, customerName: item.customerName}));
    targetObj.customerDTOList = [...targetObj.customerDTOList, ...result];
  }
  isLoadingMove.value = true
  let res = await getMailCustomerSetting({...targetObj});
  if (res.code !== 200) {
    ElMessage.error(res.message);
    isLoadingMove.value = false
    return;
  }
  ElMessage.success(res.message);
  isLoadingMove.value = false
  closePopoverVisibleAll()
  await getCustomerList();
  dialogVisibleBranch.value = false;
  checkListBranch.value = [];
  await resetInit()
};

const deleteRow = async (row, column, $index) => {
  const targetObj = {
    customerDTOList: [],
    managerDTOList: [],
    teamId: teamId.value,
    type: 2,
  };
  const checkoutUsers = checkListBranch.value.map(item => JSON.parse(item))
  targetObj.managerDTOList = [
    ...targetObj.managerDTOList,
    ...checkoutUsers,
  ];
  let newObj = null;
  if (multipleSelection.value.length === 0 || multipleSelection.value.length === 1) {
    // 单个移入公海
    newObj = JSON.parse(JSON.stringify(row));
    targetObj.customerDTOList = [...targetObj.customerDTOList, {
      customerId: newObj.id,
      customerName: newObj.customerName
    }];
    let res = await getMailCustomerSetting({...targetObj});
    if (res.code !== 200) {
      ElMessage.error(res.message);
      return;
    }
    ElMessage.success(res.message);
    await getCustomerList();
    dialogVisibleBranch.value = false;
    checkListBranch.value = [];
    await resetInit()
  } else {
    ElMessage.warning(i18n.global.t('setting.please.move.public'));
  }

}
const userInfo = computed(() => store.state.user.userInfo)
// 全选
const PaginationZQ = ref(null)
// 分管设置+追加分管
const isLoadingBranch = ref(false)
// 充值筛选
const topSearchRef = ref(null)
const handleClickSubmit = async () => {
  const checkoutUsers = checkListBranch.value.map(item => JSON.parse(item))
  let targetObj = {
    customerDTOList: [],
    managerDTOList: [],
    teamId: teamId.value,
    selectAll: isSelectAll.value,
    userId: userInfo.value.id,
    ...searchValue.value,
  };
  // 分管设置
  if (flags.value === 1) {
    // 选中的用户
    targetObj.managerDTOList = [
      ...targetObj.managerDTOList,
      ...checkoutUsers,
    ];
    targetObj.type = 1;
    let newObj = null;
    if (multipleSelection.value.length >= 1) {
      // 批量 分管设置
      newObj = JSON.parse(JSON.stringify(multipleSelection.value));
      const result = newObj.map((item) => ({customerId: item.id, customerName: item.customerName}));
      targetObj.customerDTOList = [...targetObj.customerDTOList, ...result];
    } else {
      // 单个 分管设置
      newObj = JSON.parse(JSON.stringify(activeItem.value));
      targetObj.customerDTOList = [...targetObj.customerDTOList, {
        customerId: newObj.id,
        customerName: newObj.customerName
      }];
    }
    if (isSelectAll.value) {
      delete targetObj.customerDTOList
    }
    isLoadingBranch.value = true
    let res = await getMailCustomerSetting({...targetObj});
    if (res.code !== 200) {
      isLoadingBranch.value = false
      ElMessage.error(res.message);
      return;
    }
    isLoadingBranch.value = false
    ElMessage.success(res.message);
    // 追加分管
  } else if (flags.value === 3) {
    targetObj.managerDTOList = [
      ...targetObj.managerDTOList,
      ...checkoutUsers,
    ];
    targetObj.type = 3
    const newObj = JSON.parse(JSON.stringify(multipleSelection.value));
    const result = newObj.map((item) => ({customerId: item.id, customerName: item.customerName}));
    targetObj.customerDTOList = [...targetObj.customerDTOList, ...result];
    isLoadingBranch.value = true
    let res = await getMailCustomerSetting({...targetObj});
    if (res.code !== 200) {
      isLoadingBranch.value = false
      ElMessage.error(res.message);
      return;
    }
    isLoadingBranch.value = false
    ElMessage.success(res.message);
  }
  dialogVisibleBranch.value = false;
  isSelectAll.value = false
  if (PaginationZQ.value) {
    PaginationZQ.value.isSelectAll = false
  }
  checkListBranch.value = [];
  flags.value = 0;
  await getCustomerList();
  await resetInit()
};

// 抽屉的展示
const isShowDrawers = ref(false);
// 公司信息
const companyInfo = ref([]);
// 营销信息
const marketingInfo = ref([]);
// 联系人信息
const ruleFormCustomer = computed(() => store.state.customer.ruleForm);
// 联系人
const contactInfo = ref([]);
// 档案信息
const handleClickTargetData = async (item) => {
  isShowDrawers.value = true;
  // console.log(row)
  localStorage.setItem('customerId', item.id)
  console.log(ruleFormCustomer.value, 'ruleFormCustomer')
  await store.dispatch("customer/getQueryById", {
    customerId: item.id,
  });
  console.log(ruleFormCustomer.value, 'ruleFormCustomer')
  if (ruleFormCustomer.value) {
    const {
      customerName,
      phoneWayList,
      setUpTime,
      customerOrigin,
      economicNature,
      companyWebsite,
      companyAddress,
      companyFax,
      emailWayList,
      companyRemark,
      customerOriginList,
      zoneAddress,
      // ----
      customerType,
      customerLevel,
      product,
      productList,
      marketingRemark,
      mailLabelVoList,
    } = ruleFormCustomer.value;
    console.log(ruleFormCustomer.value, customerName, 'ruleFormCustomer.value')
    // console.log('详情信息', ruleFormCustomer.value, phoneWayList.filter((item) => item.isDefault === 1)[0].content, emailWayList)
    companyInfo.value = [
      {
        name: i18n.global.t("common.region.name"),
        value: zoneAddress,
      },
      {
        name: i18n.global.t("common.customer.source"),
        value: item?.mailCustomerOriginDetailVoList?.filter(item => item.name !== '').length > 0 ? item?.mailCustomerOriginDetailVoList?.filter(item => item.name !== '') : '',
      },
      {
        name: i18n.global.t('common.establishment'), value: setUpTime
      },
      {
        name: i18n.global.t('common.economicnature'), value: economicNature
      },
      {
        name: i18n.global.t('common.cds6'),
        value:
            emailWayList.length !== 0 ? emailWayList.filter((item) => item.isDefault === 1)[0]?.content :
                [],
      },
      {
        name: i18n.global.t('common.cds2'), value: companyAddress
      },
      {
        name: i18n.global.t("more.check.phone"),
        value: phoneWayList.length !== 0 ? phoneWayList.filter((item) => item.isDefault === 1)[0]?.content :
            [],
      },
      {
        name: i18n.global.t('common.faxnumber'), value:
        companyFax
      },
      {
        name: i18n.global.t('common.company.website'), value:
        companyWebsite
      },
      {
        name: i18n.global.t('other.remark'), value:
        companyRemark
      },
    ];
    marketingInfo.value = [
      {name: i18n.global.t('common.customer.typeList'), value: customerType},
      {name: i18n.global.t('common_customer_level'), value: customerLevel},
      {
        name: i18n.global.t('common.interest.product'),
        value: item?.mailProductDetailVoList?.filter(item => item.name !== '').length > 0 ? item?.mailProductDetailVoList?.filter(item => item.name !== '') : ''
      },
      {name: i18n.global.t('create.customer.des'), value: marketingRemark},
    ];
    // 联系人详情
    await store.commit("customer/setContactPage", {
      page: 1,
      pageSize: 999,
    });
    await store.dispatch("customer/getContactList",);
    // 清除数据干扰
    contactInfo.value = [];
    // 联系人详情
    contactInfo.value = contactList.value.map((item) => [
      {name: i18n.global.t('common.name'), value: item.name},
      {name: i18n.global.t('common.email'), value: item.email},
    ]);
  }
};

// table 中的 confirm
const requestHandleDelete = (row) => {
  row.popoverVisible = true;
};
const cancelPopover = (row) => {
  row.popoverVisible = false;
};

// 审核列表
// 分页
const currentList = ref(1);
const sizeList = ref(10);
const totalsList = computed(() => store.state.customer.badgeDataApproval);
const handleCurrentChangeList = async (page) => {
  console.log(page, 'page')
  currentList.value = page;
  await getCustomerListAdmin();
};
const allAdminList = ref([]);
const getCustomerListAdmin = async () => {
  const targetObj = {
    pageNo: currentList.value,
    pageSize: sizeList.value,
    teamId: teamId.value,
  };
  isLoading.value = true
  let res = await getMailCustomerAudit({...targetObj});
  if (res.code !== 200) {
    isLoading.value = false
    ElMessage.error(res.message)
    return;
  }
  //console.log(res.result, "$$$$");
  isLoading.value = false
  const {records, size, current, total} = res.result;
  allAdminList.value = records;
  currentList.value = current;
  sizeList.value = size;
  // 徽章数据
  // totalsList.value = total;
  store.commit("customer/setApprovalBadge", total);
};

onMounted(async () => {
  // Shift监听/取消监听
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('keyup', handleKeyUp);
  if (route.query.tab) {
    activeName.value = route.query.tab;
  }
  // 确定 activeName 的值
  // const tabCheck = localStorage.getItem("tabCheck");
  // activeName.value = isSuperAdmin.value ? tabCheck ? tabCheck : "1" : "3"
  // console.log(activeName.value, ' activeName.value', isSuperAdmin.value, isSuperAdmin.value ? tabCheck ? tabCheck : "1" : "3")
  if (!isSuperAdmin.value) {
    activeName.value = "3"
  }
  // 判断 activeItem 的值并执行相应的逻辑
  if (activeName.value === "2") {
    await store.dispatch("groups/getAllUserList", {teamId: teamId.value});
    await getFollowUserList();
    // await getAllCustomer()
    nextTick(() => {
      customerSelectRefA.value?.initGetAllCustomer();
      customerSelectRefB.value?.initGetAllCustomer();
    });
  } else if (activeName.value === "3" || activeName.value === "6") {
    await store.dispatch("groups/getAllUserListNo", {teamId: teamId.value});
  } else if (activeName.value === "4") {
    await getCustomerListAdmin();
  } else if (activeName.value === '7') {
    // await getAllCustomer()
    nextTick(() => {
      customerSelectRefA.value?.initGetAllCustomer();
      customerSelectRefB.value?.initGetAllCustomer();
    });
  } else if (activeName.value === '1') {
    if (!sessionStore.get("customerLevel")) {
      await store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value});
    }
  }

  if (route.query.activeName) {
    activeName.value = route.query.activeName
  }
});

watch(() => activeName.value, async (newValue) => {
  await handleClick({props: {name: activeName.value}})
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
  document.removeEventListener('keyup', handleKeyUp);
});

watch(() => teamId.value, async () => {
  await getCustomerList();
  await getFollowUserList();
  nextTick(() => {
    customerSelectRefA.value?.initGetAllCustomer();
    customerSelectRefB.value?.initGetAllCustomer();
    store.dispatch("groups/getAllUserListNo", {teamId: teamId.value});
  });
})

const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  //console.log(row, columnIndex)
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 4 || columnIndex === 5) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 4 || columnIndex === 5) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}

let endIndex = -1;
// table 选择增加 shift
const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
const handleKeyDown = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    // console.log("进来了-----------------", event.key, event.keyCode);
    isShiftPressed.value = true;
  }
};

const handleKeyUp = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    isShiftPressed.value = false;
  }
};

const isSelectAll = ref(false);
const checkSelectableFg = (row, index) => {
  return !isSelectAll.value;
}

const checkAllItemPage = () => {
  if (activeName.value === '3') {
    targetTable.value.clearSelection()
  } else if (activeName.value === '4') {
    targetTableAll.value.clearSelection()
  }
  isSelectAll.value = true
}
const unCheckAllItemPage = () => {
  if (activeName.value === '3') {
    targetTable.value.clearSelection()
  } else if (activeName.value === '4') {
    targetTableAll.value.clearSelection()
  }
  isSelectAll.value = false
}

const getSelectValue = async (val) => {
  if (val !== undefined) {
    isSelectAll.value = val
  }
  await nextTick(() => {
    if (activeName.value === '3') {
      customerList.value.forEach((item) => {
        targetTable?.value.toggleRowSelection(item, isSelectAll.value)
      })
    } else if (activeName.value === '4') {
      allAdminList.value.forEach((item) => {
        targetTableAll?.value.toggleRowSelection(item, isSelectAll.value)
      })
    }
  })
}


const handleCheck = async (value) => {
  if (isSelectAll.value) {
    isSelectAll.value = false;
  }
  await getSelectChange(value)
}

const PaginationZQ2 = ref(null)
const resetInit = async () => {
  // parent
  isSelectAll.value = false
  // child
  await store.commit("customer/setMultipleSelection", [])
  await store.commit("customer/setGlobalSelectedRows", {});
  await store.commit("customer/setSelectedRows", {});
  if (activeName.value === '3') {
    if (PaginationZQ.value?.setIsSelectAll) {
      await PaginationZQ.value.setIsSelectAll(isSelectAll.value)
    }
    targetTable.value?.clearSelection()
  } else if (activeName.value === '4') {
    if (PaginationZQ2.value?.setIsSelectAll) {
      await PaginationZQ2.value.setIsSelectAll(isSelectAll.value)
    }
    targetTableAll.value?.clearSelection()
  }
  await topSearchRef.value?.getSelectTarget()
}

const getSelectChange = async (val) => {
  console.log(val, '当前页勾选的值');
  // 选择 底部选择 取消 全部勾选
  await nextTick(async () => {
    // 获取当前页的页码，假设分页数据存储在 store 中
    const currentPage = activeName.value === "3" ? current.value : activeName.value === '4' ? currentList.value : null;

    // 获取全局勾选记录
    const globalSelectedRows = store.state.customer.globalSelectedRows || {};

    // 更新当前页的勾选数据到全局记录
    globalSelectedRows[currentPage] = val;

    // 提交更新全局勾选记录到 store
    await store.commit("customer/setGlobalSelectedRows", globalSelectedRows);

    // 合并所有页的勾选数据
    const allSelectedRows = Object.values(globalSelectedRows).flat();

    // 更新 `selectedRows` 和 `targetEmailList`
    await store.commit("customer/setSelectedRows", allSelectedRows);
  })
}

const handleClickSelectAll = async (val) => {
  console.log(val, '当前页勾选的值');
  // 获取当前页的页码，假设分页数据存储在 store 中
  const currentPage = activeName.value === "3" ? current.value : activeName.value === '4' ? currentList.value : null;

  // 获取全局勾选记录
  const globalSelectedRows = store.state.customer.globalSelectedRows || {};

  // 更新当前页的勾选数据到全局记录
  globalSelectedRows[currentPage] = val;

  // 提交更新全局勾选记录到 store
  await store.commit("customer/setGlobalSelectedRows", globalSelectedRows);

  // 合并所有页的勾选数据
  const allSelectedRows = Object.values(globalSelectedRows).flat();

  // 更新 `selectedRows` 和 `targetEmailList`
  await store.commit("customer/setSelectedRows", allSelectedRows);
}
const selectedRows = computed(() => store.state.customer.selectedRows)
const globalSelectedRows = computed(() => store.state.customer.globalSelectedRows)
const isCounterElection = computed(() => store.state.customer.isCounterElection);
// 记录历史记录
const resetSelection = async () => {
  await nextTick(() => {
    if (activeName.value === '3') {
      if (targetTable?.value && selectedRows?.value.count > 0) {
        customerList.value.forEach((item) => {
          const isSelected = selectedRows.value?.some((selected) => selected.id === item.id);
          console.log(item, isSelected, selectedRows.value.map(item => item.id), 'isSelected')
          targetTable?.value.toggleRowSelection(item, isSelected);
        })
      }
    } else if (activeName.value === '4') {
      if (targetTableAll?.value && selectedRows?.value.count > 0) {
        allAdminList.value.forEach((item) => {
          const isSelected = selectedRows.value?.some((selected) => selected.id === item.id);
          console.log(item, isSelected, selectedRows.value.map(item => item.id), 'isSelected')
          targetTableAll?.value.toggleRowSelection(item, isSelected);
        })
      }
    }
  })
}

// 当前页数据发生变化
watch(() => customerList.value, (newValue) => {
  if (newValue) {
    console.log('newValue')
    resetSelection()
  }
}, {immediate: true})

watch(() => allAdminList.value, (newValue) => {
  if (newValue) {
    console.log('newValue')
    resetSelection()
  }
}, {immediate: true})

const checkSelectableSP = () => {
  return !isSelectAll.value;
}

const clearVisiblePopover = () => {
  setTimeout(() => {
    visiblePopover.value = false
  }, POPOVER_DELAY_TIME + 10)
}

const lang = computed(() => store.state.system.langLocal)
const middleValueWidth = ref(160)
// 字数大致限制
const sizeMaxNumber = ref(16)
const handleClickSelectWidth = (item, type) => {

  const tableData = type === 'admin' ? allAdminList.value : customerList.value

  if (item.value === "customerCode") {
    return flexWidth('customerCode', tableData, i18n.global.t('common_customer_number')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerCode', tableData, i18n.global.t('common_customer_number')) + 20
  } else if (item.value === "customerType") {
    return flexWidth('customerType', tableData, i18n.global.t('common_customer_type')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerType', tableData, i18n.global.t('common_customer_type')) + 20
  } else if (item.value === 'customerOrigin') {
    return flexWidth('customerOrigin', tableData, i18n.global.t('common.customer.source')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerOrigin', tableData, i18n.global.t('common.customer.source')) + 50
  } else if (item.value === 'customerIntention') {
    return flexWidth('customerIntention', tableData, i18n.global.t('common.interest.product')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerIntention', tableData, i18n.global.t('common.interest.product')) + 50
  } else if (item.value === 'createName') {
    if (flexWidth('createName', tableData, i18n.global.t('common.byinput')) > middleValueWidth.value) {
      return middleValueWidth.value
    } else {
      if (flexWidth('createName', tableData, i18n.global.t('common.byinput')) < 80) {
        return 80
      } else {
        return flexWidth('createName', tableData, i18n.global.t('common.byinput'))
      }
    }
  } else if (item.value === 'userName') {
    if (activeName.value === '3') {
      return 80
    } else if (activeName.value === '4') {
      return flexWidth('userName', tableData, i18n.global.t('common.applicant')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('userName', tableData, i18n.global.t('common.applicant'))
    }
  } else if (item.value === 'maiContactVOList' || item.value === 'zoneAddress' || item.value === 'auditName') {
    return 80;
  } else if (item.value === 'customerLevel') {
    return lang.value !== 'zh-CN' ? 120 : 80;
  } else if (item.value === 'lastTime' || item.value === 'applyTime' || item.value === 'followTime') {
    return 150;
  } else if (item.value === 'auditStatus') {
    return 120;
  } else if (item.value === 'setting') {
    console.log(lang.value, 'lang.value')
    if (activeName.value === '3') {
      return lang.value === 'en' ? 500 : 120;
    } else if (activeName.value === '4') {
      return 120
    }
  } else if (item.value === 'mangerVOList' || item.value === 'manageId') {
    return 80;
  } else {
    return "auto"
  }
}


const handleClickSelectMinWidth = (item) => {
  if (item.value === "customerName") {
    return 120;
  } else {
    return 140;
  }
}
const overflowMap = reactive({})

const setRef = (el, row) => {
  if (!el) return
  refMap[row.id] = el

  nextTick(() => {
    overflowMap[row.id] = Math.ceil(el.scrollWidth) >= Math.ceil(el.clientWidth)
  })
}

const handleMouseEnter = (row) => {
  if (overflowMap[row.id]) {
    handleRef(refMap[row.id], row, 5)
  }
}

</script>

<style scoped lang="less">
@import "../../less/page.less";
@import "./less/setting.less";

.pages :deep(.el-pagination .el-select) {
  width: 100px !important;
}

.pages {
  margin-top: 10px;
}

.small_box {
  width: auto !important;
}

:deep(.el-table__inner-wrapper::before) {
  content: none !important;
  display: none !important;
}

.demo-image__lazy {
  height: 526px;
  overflow-y: auto;
}

.demo-image__lazy .el-image {
  display: block;
  min-height: 526px;
  margin-bottom: 10px;
}

.demo-image__lazy .el-image:last-child {
  margin-bottom: 0;
}

:deep(.el-table__empty-block) {
  height: 200px !important;
}

.select_sp .el-select-dropdown__item {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

:deep(.el-button) {
  font-size: 13px !important;
  font-weight: normal !important;
}

:deep(.el-form-item__label) {
  font-size: 14px !important;
  font-weight: normal !important;
}

//:deep(.el-form-item) {
//  margin-bottom: 24px !important;
//}
:deep(.el-table__empty-block) {
  height: 200px !important;
}

.customer_title {
  font-size: 14px;
  font-weight: 500;
}

:deep(.el-table__header) {
  width: 499px !important;
}

:deep(.el-table__body) {
  width: 499px !important;
}

.font_targert {
  font-size: 14px;
  color: black;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

.card_box {
  background: #f5f5f5;
  padding: 8px;
}
</style>
